export default __webpack_public_path__ + "static/media/KiaBG2.76c8b7f1.jpg";